/* eslint-disable react/display-name */
import { readonlySelector } from '@smartsheet-dataflow/formjs';
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { PartialBy } from '../../../utils/types';

interface WithFormJSReadonlyProps {
  readonly: boolean;
}

export const withFormJSReadonly =
  <P extends EntityId & WithFormJSReadonlyProps>(
    Component: React.ComponentType<P>
  ) =>
  (props: PartialBy<P, 'readonly'>) => {
    const readonly = useSelector(readonlySelector(props.id));
    return <Component {...(props as P)} readonly={readonly} />;
  };
